import type { GridFilterModel } from '@packages/fenrir/components';
import { getUnixTimestamp } from '@packages/utils/date-time-functions/date-time-functions';

export const getStringArray = (value: string | string[] | undefined) => {
  return value && value.length > 0 ? value : undefined;
};

export const getString = (value: string | string[]) => {
  return value ? value : undefined;
};

export const getDateValue = (value: string | string[]) => {
  if (Array.isArray(value)) value = value[0];
  return value ? getUnixTimestamp(value) : undefined;
};

export const getDateArray = (value: string | string[] | undefined) => {
  if (Array.isArray(value) && value.length > 0)
    return value.map((date) => getUnixTimestamp(date));
  return undefined;
};

export const getParam = (
  field: string,
  params: GridFilterModel,
  operator?: string,
) => {
  return params.items.find((p) => {
    if (operator && p.operator !== operator) return false;
    return p.field === field;
  })?.value;
};
